import React from 'react';

const Contact = () => {
  return (
    <div className="px-4 sm:px-4 md:px-24 mx-auto md:mb-0 mb-5 tracking-wide">
      <div className="flex flex-col md:flex-row gap-10 justify-between">
        {/* Left Section */}
        <div className="space-y-6 w-full md:w-2/3">
          <form className="space-y-6 w-full">
            <div>
              <h1 className="text-sm sm:text-2xl md:text-[36px] font-bold tracking-wide text-[#03897B]">
                CONTACT US
              </h1>
              <p className="text-xs sm:text-base md:text-[32px] tracking-wide md:leading-[1.30] md:mt-12 mt-4 md:mb-8 mb-4 font-light">
                Got any questions about our services, we are here to help. Chat with our team 24/7 for help
              </p>
            </div>

            <div className="flex  md:flex-row gap-4">
              <div className="w-full">
                <label htmlFor="firstName" className="block text-xs sm:text-base md:text-[24px] font-semibold text-black mb-3">
                  First Name
                </label>
                <input
                  type="text"
                  id="firstName"
                  placeholder="First Name"
                  className="w-full py-2 sm:py-3 md:px-6 px-3 md:py-4 text-xs md:text-3xl text-black border-[#979797] border-2 rounded-md ring-0 focus:ring-2 focus:ring-[#03897B] placeholder-black"
                />
              </div>
              <div className="w-full">
                <label htmlFor="lastName" className="block text-xs sm:text-base md:text-[24px] font-semibold text-black mb-2">
                  Last Name
                </label>
                <input
                  type="text"
                  id="lastName"
                  placeholder="Last Name"
                  className="w-full md:px-6 px-3 py-2 sm:py-3 md:py-4 text-xs md:text-3xl border-[#979797] border-2 rounded-md ring-0 focus:ring-2 focus:ring-[#03897B] placeholder-black"
                />
              </div>
            </div>

            <div>
              <label htmlFor="email" className="block text-xs md:mb-4 sm:text-base md:text-[24px] font-semibold text-black">
                Email
              </label>
              <input
                type="email"
                id="email"
                placeholder="you@email.com"
                className="w-full md:px-6 px-3 py-2 sm:py-3 md:py-4 border-[#979797] border-2 mt-2 text-xs md:text-3xl rounded-md ring-0 focus:ring-2 focus:ring-[#03897B] placeholder-black"
              />
            </div>

            <label htmlFor="country" className="block text-xs sm:text-base md:text-[24px] font-semibold text-black mb-3">
  Phone Number
</label>
<div className="flex flex-row items-stretch w-full">
  {/* Blue Box (Country Select) */}
  <div className="relative z-20">
    <select
      id="country"
      className="h-full  md:w-[125px] md:px-4  px-2 w-[50px] py-2 sm:py-3 md:py-4 text-xs md:text-3xl bg-[#03897B] text-white  rounded-[5px] rounded-l-md focus:outline-none focus:ring-2 focus:ring-[#03897B] appearance-none"
      style={{
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    backgroundImage: "none",
                  }}
    >
      <option value="ZA">ZA</option>
      <option value="NG">NG</option>
      <option value="KE">KE</option>
    </select>
    {/* Dropdown Arrow */}
    <div className="absolute top-1/2 md:right-3 right-2 md:w-[40px] md:h-[40px] h-[17px] w-[17px] transform -translate-y-1/2 text-white pointer-events-none">
      <svg xmlns="http://www.w3.org/2000/svg"  fill="none" viewBox="0 0 24 24">
        <path d="M6 9l6 6 6-6" stroke="white" strokeWidth="1.5" />
      </svg>
    </div>
  </div>

  {/* Phone Input */}
  <input
    type="tel"
    id="phone"
    placeholder="+276475XXXXX"
    className="flex-1 px-4 py-2 sm:py-3 md:py-4 text-xs md:text-3xl border-[#979797] border-l-0 rounded-r-md focus:outline-none focus:ring-2 focus:ring-[#03897B] placeholder-black"
  />
</div>



            <div className="md:h-1"></div>
            <label htmlFor="message" className="block text-xs sm:text-base md:text-[24px] font-semibold text-black mb-3">
              Message
            </label>
         <div className='md:hidden block'>
         <div className="md:mt-10 md:mb-3 mt-6">
        <textarea
          id="message"
          placeholder="Send Us a Message"
          className="w-full px-3 py-2 border-[#979797] border-2 rounded-md ring-0 focus:ring-2 focus:ring-[#03897B] text-xs md:text-3xl h-[180px] placeholder-black"
        />
      </div>

      <div className="space-y-2 mt-5 mb-5">
        <h2 className="text-xs sm:text-lg md:text-[24px] font-semibold text-black mb-5">Services</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          {[
            "Service providers",
            "Resources",
            "Market",
            "Contracts",
            "Investments",
            "Communities",
            "ESG",
            "Enterprise",
            "General"
          ].map((service, index) => (
            <div key={index} className="flex items-center space-x-2">
              <input
                type="checkbox"
                id={`service${index}`}
                className="h-4 w-4 md:h-8 md:w-8 bg-[#D9D9D9] rounded-[4px]"
              />
              <label
                htmlFor={`service${index}`}
                className="text-xs sm:text-base md:text-[24px] text-black font-semibold"
              >
                {service}
              </label>
            </div>
          ))}
        </div>
      </div>

      <button
        type="submit"
        className="bg-[#03897B] text-white py-2 sm:py-3 text-xs md:text-4xl font-bold w-full rounded-[6px] mt-4"
      >
        Send Message
      </button>
         </div>
          </form>
        </div>

        {/* Right Section */}
        <div className="space-y-6 w-full md:w-[45%] mt-6 md:mt-20 ">
          <h1 className="text-xs md:text-4xl font-bold text-black">Chat with us</h1>
          <p className="text-xs md:text-4xl font-light text-black mb-3 -mt-3">
            Speak to our friendly team <br/>via live chat
          </p>

          <div className="md:space-y-6 space-y-3">
            {[
              {
                label: "Start a live chat",
                icon: "image_1569_qv1gio.png"
              },
              {
                label: "Send us an email",
                icon: "image_vwkadq.png"
              }
            ].map((item, i) => (
              <div className="flex items-center gap-3" key={i}>
                <img
                  src={`https://res.cloudinary.com/dzngpgki4/image/upload/v1743940484/${item.icon}`}
                  alt={item.label}
                  className="w-5 h-5 sm:w-8 sm:h-8"
                />
                <p className="text-xs sm:text-xl md:text-[32px] font-normal text-black">{item.label}</p>
              </div>
            ))}
          </div>

          <div className="md:space-y-4 space-y-2  ">
          <div className='md:h-[1px]'></div>
            <p className="text-xs sm:text-2xl md:text-[36px] font-bold text-black tracking-wide">Message Us</p>
            <div className="grid grid-cols-1 md:gap-6 gap-2">
              {[
                { label: "Whatsapp", icon: "image-1_skfnsd.png" },
                { label: "Facebook", icon: "image_15_g4mwse.png" },
                { label: "Instagram", icon: "image_sgphk8.png" },
                { label: "Tiktok", icon: "image-4_cgzic4.png" },
                { label: "Youtube", icon: "image-1_fs5c12.png" },
                { label: "Linked In", icon: "image-2_mymqwj.png" },
                { label: "X", icon: "image-7_ytyl9r.png" }
              ].map((item, index) => (
                <a
                  key={index}
                  href="https://facebook.com"
                  className="flex items-center gap-3 text-xs sm:text-lg md:text-[32px] hover:underline"
                >
                  <img
                    src={`https://res.cloudinary.com/dzngpgki4/image/upload/v1743863799/${item.icon}`}
                    alt={item.label}
                    className="w-5 h-5 sm:w-8 sm:h-8"
                  />
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="md:mt-10 md:mb-3 mt-6 md:block hidden">
        <textarea
          id="message"
          placeholder="Send Us a Message"
          className="w-full md:px-8 px-3 md:py-4 py-2 border-[#979797] border-2 rounded-md ring-0 focus:ring-2 focus:ring-[#03897B] text-xs md:text-3xl h-[180px] placeholder-black"
        />
      </div>

      <div className="space-y-2 mt-5 mb-5 md:block hidden">
        <h2 className="text-xs sm:text-lg md:text-[24px] font-semibold text-black mb-5">Services</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4 md:max-w-3xl">
          {[
            "Service providers",
            "Resources",
            "Market",
            "Contracts",
            "Investments",
            "Communities",
            "ESG",
            "Enterprise",
            "General"
          ].map((service, index) => (
            <div key={index} className="flex items-center space-x-2">
              <input
                type="checkbox"
                id={`service${index}`}
                className="h-4 w-4 md:h-8 md:w-8 bg-[#D9D9D9]  border-[2px] border-black rounded-[4px]"
              />
              <label
                htmlFor={`service${index}`}
                className="text-xs sm:text-base md:text-[24px] text-black font-semibold"
              >
                {service}
              </label>
            </div>
          ))}
        </div>
      </div>

      <button
        type="submit"
        className="bg-[#03897B] md:mb-20 md:block hidden text-white py-2 sm:py-3 text-xs md:text-4xl font-bold w-full rounded-[6px] mt-4"
      >
        Send Message
      </button>
    </div>
  );
};

export default Contact;
